<script setup lang="ts">
import nav from '~/constants/menu.js';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { type NavItem } from '~/types/nav';
import axios from 'axios';
import ArrowLeftIcon from '~/components/icons/arrow-left.vue';
import { useRoute } from '#app';

const sidebar = ref<HTMLElement | null>(null);
const open = ref(false);
const selectedNav = ref<string>('');
const subnav = ref<NavItem[] | null>(null);
const loaded = ref(false);
const fuhrparklist = ref(false);
const Transponderlist = ref(false);
const loggeduser = ref<string | null>(localStorage.getItem('windows_name'));
const loginlist = ref<string[]>([
    'm.kahl',
    'li.schmidt',
    'g.kopka',
    'o.hafsi',
    'm.hauptlorenz',
    'j.motzelt',
    'f.steyer',
    'a.markau',
    'j.sacht',
    'h.fouladikia',
    'a.morovati',
]);
const login_bundes_liste = ref<string[]>([
    'g.kopka',
    'f.steyer',
    'a.markau',
    'h.fouladikia',
    'a.morovati',
    'o.cekmareva',
    'h.knoll',
    'a.tischendorf',
    'o.hecker',
    'b.abraham',
    'm.hollstein',
    'j.sacht',
]);
const isAuthorizedemail = loginlist.value.includes(loggeduser.value ?? '');
const isAuthorizeded_bundesliste = login_bundes_liste.value.includes(
    loggeduser.value ?? ''
);
const route = useRoute();

const sidebarStorage = useCookie<boolean>('sidebar');

const toggleSidebar = () => {
    open.value = !open.value;
    sidebarStorage.value = open.value;
    closeSubnav();
};

const selectNav = (item: NavItem) => {
    if (selectedNav.value === item.id) {
        closeSubnav();
        return;
    }

    openSubnav(item);
};

function openSubnav(item: NavItem) {
    if (item.subs) {
        subnav.value = item.subs;
        selectedNav.value = item.id;
    }
}

function closeSubnav() {
    subnav.value = null;
    selectedNav.value = '';
}

function clickOutside(e: MouseEvent) {
    if (sidebar.value && !sidebar.value.contains(e.target as Node)) {
        closeSubnav();
    }
}

function toggleSubmenu(id) {
    const item = subnav.value?.find((item) => item.id === id);

    if (item) {
        if (item.showSubs === undefined) {
            item.showSubs = true;
        }
        item.showSubs = !item.showSubs;
    }
}

function goToPage(to: string) {
    closeSubnav();
    navigateTo(to);
}

const selectedPage = computed(() => {
    for (const item of nav) {
        if (item.to === route.path) {
            return { item: item.id };
        } else if (item.subs) {
            for (const subitem of item.subs) {
                if (subitem.to === route.path) {
                    return {
                        item: item.id,
                        subitem: subitem.to,
                    };
                } else if (subitem.subs) {
                    for (const subsubitem of subitem.subs) {
                        if (subsubitem.to === route.path) {
                            return {
                                item: item.id,
                                subsubitem: subsubitem.to,
                            };
                        }
                    }
                }
            }
        }
    }
});
const get_fuhrparklist = async () => {
    try {
        const token = sessionStorage.getItem("temp_tok_laravel");
        const { data } = await axios.get(
            ' https://api.tempton-connect.de/api/digital/Fuhrpark_Users',
            {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }
        );
        var loggeduserfuhrlist = localStorage.getItem('windows_name');
        const isFound = data.data.some((element) => {
            if (element.Username === loggeduserfuhrlist) {
                return true;
            }
            return false;
        });
        if (isFound == true) {
            fuhrparklist.value = true;
        }
    } catch (error) {
        console.error('Error fetching user tree access:', error);
    }
};
const get_Transponderlist = async () => {
    try {
        const token = sessionStorage.getItem("temp_tok_laravel");
        const { data } = await axios.get(
            ' https://api.tempton-connect.de/api/digital/transponder_time',
            {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }
        );
        var loggeduserlist = localStorage.getItem('windows_name');
        const isFound = data.data.some((element) => {
            if (element.Windowsnutzer === loggeduserlist) {
                return true;
            }
            return false;
        });
        if (isFound == true) {
            Transponderlist.value = true;
        }
    } catch (error) {
        console.error('Error fetching user tree access:', error);
    }
};
onMounted(() => {
    window.addEventListener('click', clickOutside);
    open.value = sidebarStorage.value ?? false;
    setTimeout(() => (loaded.value = true), 100);
    if (loggeduser !== null) {
        loggeduser.value = localStorage.getItem('windows_name') ?? '';
    }
    get_fuhrparklist();
    get_Transponderlist();
});

onBeforeUnmount(() => {
    window.removeEventListener('click', clickOutside);
});
</script>

<template>
    <aside
        ref="sidebar"
        class="shadow-md flex bg-white relative"
        :class="[
            !open ? 'w-60' : 'w-20',
            loaded ? 'transition-all ease-linear' : '',
        ]"
    >
        <div class="divide-y w-full">
            <template v-for="item in nav" :key="item.id">
                <template v-if="item.to">
                    <div
                        v-if="
                            (isAuthorizedemail && item.id === 'notshow_main') ||
                            (fuhrparklist && item.id === 'fuhrpark') ||
                            item.id === 'second-menu' ||
                            item.id === 'piaf' ||
                            item.id === 'digital-menu' ||
                            item.id === 'single' ||
                            item.id === 'arbeitsplatz'
                        "
                        @click="goToPage(item.to)"
                        class="my-2 p-4 flex flex-col gap-2 items-center justify-center text-center cursor-pointer hover:text-primary w-full"
                        :class="[
                            !open ? 'p-2' : 'p-10',
                            selectedPage?.item === item.id
                                ? 'text-primary'
                                : '',
                        ]"
                    >
                        <i :class="item.icon" class="text-3xl" />
                        <span class="text-sm" v-show="!open">{{
                            item.label
                        }}</span>
                    </div>
                </template>

                <template v-else>
                    <div
                        v-if="
                            (isAuthorizedemail && item.id === 'notshow_main') ||
                            (fuhrparklist && item.id === 'fuhrpark') ||
                            item.id === 'second-menu' ||
                            item.id === 'piaf' ||
                            item.id === 'digital-menu' ||
                            item.id === 'single'||
                            item.id === 'arbeitsplatz'
                        "
                        @click="selectNav(item)"
                        class="my-2 p-4 flex flex-col gap-2 items-center justify-center text-center cursor-pointer hover:text-primary w-full"
                        :class="[
                            !open ? 'p-2' : 'p-10',
                            selectedPage?.item === item.id
                                ? 'text-primary'
                                : '',
                        ]"
                    >
                        <i :class="item.icon" class="text-3xl" />
                        <span class="text-sm" v-show="!open">{{
                            item.label
                        }}</span>
                    </div>
                </template>
            </template>
        </div>

        <div>
            <div
                v-if="subnav"
                class="bg-white space-y-4 border-l pt-10 pb-20 px-14 h-full overflow-y-auto absolute z-10 w-max left-full"
            >
                <template v-for="subitem in subnav" :key="subitem.id">
                    <div
                        v-if="subitem.subs"
                        class="flex gap-2 items-center cursor-pointer hover:text-primary"
                        @click="toggleSubmenu(subitem.id)"
                    >
                        <i
                            :class="[
                                subitem.showSubs ?? true
                                    ? 'simple-icon-arrow-down'
                                    : 'simple-icon-arrow-right',
                                'font-simpleicons',
                            ]"
                        />
                        <span class="text-sm">{{ subitem.label }}</span>
                    </div>
                    <div
                        v-else
                        @click="goToPage(subitem.to)"
                        class="flex gap-2 items-center cursor-pointer hover:text-primary"
                        :class="[
                            selectedPage?.subitem === subitem.to
                                ? 'text-primary'
                                : '',
                        ]"
                    >
                        <i :class="subitem.icon" />
                        <span class="text-sm">{{ subitem.label }}</span>
                    </div>

                    <div
                        v-if="subitem.subs && (subitem.showSubs ?? true)"
                        class="ml-6"
                    >
                        <template
                            v-for="subsubitem in subitem.subs"
                            :key="subsubitem.id"
                        >
                            <div
                                v-if="
                                    (subsubitem.id === 'show_ziel' &&
                                        isAuthorizeded_bundesliste) ||
                                    (subsubitem.id === 'transponder' &&
                                        Transponderlist) ||
                                    !subsubitem.id
                                "
                                @click="goToPage(subsubitem.to)"
                                class="p-4 flex gap-2 items-center cursor-pointer hover:text-primary"
                                :class="[
                                    selectedPage?.subsubitem === subsubitem.to
                                        ? 'text-primary'
                                        : '',
                                ]"
                            >
                                <i :class="subsubitem.icon" />
                                <span class="text-sm">{{
                                    subsubitem.label
                                }}</span>
                            </div>
                        </template>
                    </div>
                </template>
            </div>

            <button
                type="button"
                v-if="!subnav"
                class="absolute bg-white p-1 top-1/2 transform -translate-y-1/2 rounded-r-md z-20 transition-all ease-linear"
                :class="
                    !open
                        ? 'left-full -translate-x-0.5'
                        : 'left-full -translate-x-0.5'
                "
                @click="toggleSidebar"
            >
                <ArrowLeftIcon :class="{ 'rotate-180': open }" />
            </button>
        </div>
    </aside>
</template>

<style scoped></style>
